if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends window.BAO.CustomElement() {
      connectedCallback () {
        this.els.tab.elements.forEach(element => {
          element.addEventListener(
            'click',
            this.handleTabInteraction.bind(this),
          )
          element.addEventListener(
            'focus',
            this.handleTabInteraction.bind(this),
          )
        })

        this.els.list.element.addEventListener('keydown', event => {
          this.handleArrowKey(event)
          this.handleHomeKey(event)
          this.handleEndKey(event)
        })

        this.checkOverflowAndApplyStyle()
      }

      handleTabInteraction (event) {
        this.moveSelectedTabState(
          this.els.tab.elements.indexOf(event.currentTarget),
        )
        this.moveSelectedPanelState(
          this.els.tab.elements.indexOf(event.currentTarget),
        )
      }

      handleArrowKey (event) {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          const currentIndex = this.els.tab.elements.indexOf(
            document.activeElement,
          )
          const nextIndex =
            event.key === 'ArrowRight' ? currentIndex + 1 : currentIndex - 1
          const nextElement =
            this.els.tab.elements[nextIndex] || this.els.tab.elements[0]
          nextElement.focus()
        }
      }

      handleHomeKey (event) {
        if (event.key === 'Home') {
          event.preventDefault()
          this.els.tab.elements[0].focus()
        }
      }

      handleEndKey (event) {
        if (event.key === 'End') {
          event.preventDefault()
          this.els.tab.elements[this.els.tab.elements.length - 1].focus()
        }
      }

      moveSelectedTabState (index) {
        this.els.tab.elements.forEach((element, i) => {
          element.setAttribute('aria-selected', i === index ? 'true' : 'false')
        })
      }

      moveSelectedPanelState (index) {
        this.els.panel.elements.forEach((element, i) => {
          element.setAttribute('aria-hidden', i !== index)
        })
      }

      checkOverflowAndApplyStyle () {
        const listElement = this.els.list.element
        if (listElement.scrollWidth > listElement.clientWidth) {
          listElement.style.justifyContent = 'flex-start'
        }
      }
    },
  )
}
